import axios from 'axios'
import { Message } from 'element-ui'

let isLoggingOut = false

const deleteAuth = () => {
  if (isLoggingOut) return
  isLoggingOut = true

  const user = JSON.parse(localStorage.getItem('user'))

  if (user) {
    apiRequestLogout()
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        localStorage.removeItem('user')
        isLoggingOut = false
        window.location = '#/login'
      })
  } else {
    isLoggingOut = false
    window.location = '#/login'
  }
}

// Intercepta as requisicoes e passa o token no header
axios.interceptors.request.use(
  config => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      if (config.url.includes('v2')) {
        if (config.url.includes('refresh')) {
          config.headers.Authorization = 'Bearer '.concat(user.refresh_token)
        } else {
          config.headers.Authorization = 'Bearer '.concat(user.access_token)
        }
      } else {
        config.headers.Authorization = 'jwt '.concat(user.access_token)
      }
    }
    return config
  },
  err => {
    console.log(err)
    return Promise.reject(err)
  }
)

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

// Intercepta as respostas e trata possiveis erros
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      console.log(error.response.config.url)
      // Em caso de erro de autenticacao (HTTP 401) rejeita a promise
      if (error.response.status === 401) {
        const requestUrl = error.response.config.url

        // Login com credenciais invalidas nao deve acionar refresh/logout global.
        if (requestUrl.includes('login')) {
          return Promise.reject(error)
        }

        // Se o erro veio do refresh ou do logout, encerra a sessão sem tentar novamente
        if (requestUrl.includes('refresh') || requestUrl.includes('logout')) {
          deleteAuth()
          Message.error('Desculpe, sua sessão expirou!')
          return Promise.reject(error)
        }

        const originalRequest = error.config
        const user = JSON.parse(localStorage.getItem('user'))

        // Sem usuario autenticado, nao ha token para renovar.
        if (!user) {
          return Promise.reject(error)
        }

        // Evita loop infinito caso a mesma requisicao falhe novamente com 401.
        if (originalRequest._retry) {
          return Promise.reject(error)
        }

        // Se já está fazendo refresh, coloca a requisição na fila e aguarda
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject })
          }).then(token => {
            originalRequest.headers.Authorization = originalRequest.url.includes('v2')
              ? 'Bearer '.concat(token)
              : 'jwt '.concat(token)
            return axios.request(originalRequest)
          }).catch(err => Promise.reject(err))
        }

        originalRequest._retry = true
        isRefreshing = true

        return apiRefreshToken()
          .then(data => {
            user.access_exp = data.access_exp
            user.access_token = data.access_token
            user.refresh_exp = data.refresh_exp
            user.refresh_token = data.refresh_token
            localStorage.setItem('user', JSON.stringify(user))
            if (error.response.config.url.includes('v2')) {
              axios.defaults.headers.common['Authorization'] = 'Bearer '.concat(data.access_token)
              error.config.headers.Authorization = 'Bearer '.concat(data.access_token)
            } else {
              axios.defaults.headers.common['Authorization'] = 'jwt '.concat(data.access_token)
              error.config.headers.Authorization = 'jwt '.concat(data.access_token)
            }
            processQueue(null, data.access_token)
            return axios.request(error.config)
          })
          .catch(err => {
            processQueue(err, null)
            return Promise.reject(err)
          })
          .finally(() => {
            isRefreshing = false
          })
      }

      var errorMsg = error.response.data &&
        error.response.data.error &&
        error.response.data.error[0] &&
        error.response.data.error[0].msg

      var resultError = error.response.data &&
        error.response.data.result &&
        error.response.data.result[0] &&
        error.response.data.result[0].error



      if (errorMsg) {
        // Varre o JSON de retorno e monta a mensagem em topicos
        let messageApi = '<ul>'
        for (var key in error.response.data.error) {
          messageApi =
            messageApi + '<li>' + error.response.data.error[key].msg + '</li>'
        }
        messageApi = messageApi + '</ul>'
        Message.warning({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: messageApi,
          duration: 10000 // 10 seg
        })
      } else if (resultError) {
        // Varre o JSON de retorno e monta a mensagem em topicos
        let messageApi = '<ul>'
        for (var key in error.response.data.result) {
          messageApi =
            messageApi + '<li>' + error.response.data.result[key].error + '</li>'
        }
        messageApi = messageApi + '</ul>'
        Message.warning({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: messageApi,
          duration: 10000 // 10 seg
        })
      } else {
        if (error.response.status !== 401) {
          if (error.response.data.message) {
            Message.warning({
              showClose: true,
              message: error.response.data.message,
              duration: 5000 // 5 seg
            })
          } else {
            Message.warning({
              showClose: true,
              message: error.response.data.error,
              duration: 5000 // 5 seg
            })
          }
        }
      }
      return Promise.reject(error)
    } else if (error) {
      // Remove a autenticação
      deleteAuth()
      Message.error('Erro desconhecido!')
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

axios.defaults.baseURL = 'https://api.mrstorage.com.br/'
// axios.defaults.baseURL = 'http://127.0.0.1:7000/v1/'
axios.defaults.timeout = 30000

const apiRefreshToken = () => {
  return axios.post('v2/refresh').then(res => res.data)
}

const apiRequestLogout = () => {
  return axios.post('v2/logout').then(res => res.data)
}

export const apiRequestLogin = params => {
  return axios.post('v2/login', params).then(res => res.data)
}

export const apiGetCnpj = params => {
  return axios.get('v2/clientes/lista/' + params).then(res => res.data)
}

export const apiGetListaNfeGeral = params => {
  return axios.get('v2/nfe/consulta', { params: params }).then(res => res.data)
}

export const apiGetEventosNfe = params => {
  return axios
    .get('v2/nfe/consulta/eventos', { params: params })
    .then(res => res.data)
}

export const apiDownloadXmlNfe = (chave, evento, sequencia) => {
  return axios
    .get('v2/nfe/xml/' + chave + '/' + evento + '/' + sequencia)
    .then(res => res.data)
}

export const apiGetDanfeNfe = chave => {
  return axios({
    headers: { Accept: 'application/pdf' },
    url: 'v2/nfe/xml/danfe/' + chave,
    method: 'GET',
    responseType: 'blob' // important
  }).then(response => {
    const blob = new Blob([response.data], { type: 'application/pdf' })
    return blob
  })
}

export const apiSendEmailNfe = (nfeChave, mailTo, mailReply) => {
  return axios
    .post('v2/nfe/email/' + nfeChave + '/' + mailTo + '/' + mailReply)
    .then(res => res.data)
}

export const apiChangePassword = params => {
  return axios.put('v2/users/alterar-senha', params).then(res => res.data)
}

export const apiResetPassword = (params) => {
  return axios.post('v2/admin/usuarios/redefinir-senha', params).then(res => res.data)
}

export const apiGetUsers = params => {
  return axios.get('v2/admin/usuarios', { params: params }).then(res => res.data)
}

export const apiDeleteUser = id => {
  return axios.delete('v2/admin/usuarios/' + id).then(res => res.data)
}

export const apiUpdateUser = (id, params) => {
  return axios.put('v2/admin/usuarios/' + id, params).then(res => res.data)
}

export const apiInsertUser = params => {
  return axios.post('v2/admin/usuarios', params).then(res => res.data)
}

export const apiGetCidades = () => {
  return axios.get('v2/admin/cidades').then(res => res.data)
}

export const apiGetClientes = params => {
  return axios.get('v2/admin/clientes', { params: params }).then(res => res.data)
}

export const apiDeleteCliente = cnpj => {
  return axios.delete('v2/admin/clientes/' + cnpj).then(res => res.data)
}

export const apiUpdateCliente = (cnpj, params) => {
  return axios.put('v2/admin/clientes/' + cnpj, params).then(res => res.data)
}

export const apiInsertCliente = params => {
  return axios.post('v2/admin/clientes', params).then(res => res.data)
}

export const apiGetClientesForUsers = () => {
  return axios.get('v2/admin/usuarios/clientes').then(res => res.data)
}

export const apiDeleteAuth = () => {
  return deleteAuth()
}


// WEBPACK FOOTER //
// ./src/api/api.js